import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f86cb61c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sk-fading-circle d-inline-flex" }

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Spinner',
  props: {
  color: String,
},
  setup(__props) {

const props = __props;



const colorRef = computed(() => props.color ?? 'white')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "sk-circle1 sk-circle",
      style: _normalizeStyle({ '--spinner-color': colorRef.value })
    }, null, 4),
    _createElementVNode("div", {
      class: "sk-circle2 sk-circle",
      style: _normalizeStyle({ '--spinner-color': colorRef.value })
    }, null, 4),
    _createElementVNode("div", {
      class: "sk-circle3 sk-circle",
      style: _normalizeStyle({ '--spinner-color': colorRef.value })
    }, null, 4),
    _createElementVNode("div", {
      class: "sk-circle4 sk-circle",
      style: _normalizeStyle({ '--spinner-color': colorRef.value })
    }, null, 4),
    _createElementVNode("div", {
      class: "sk-circle5 sk-circle",
      style: _normalizeStyle({ '--spinner-color': colorRef.value })
    }, null, 4),
    _createElementVNode("div", {
      class: "sk-circle6 sk-circle",
      style: _normalizeStyle({ '--spinner-color': colorRef.value })
    }, null, 4),
    _createElementVNode("div", {
      class: "sk-circle7 sk-circle",
      style: _normalizeStyle({ '--spinner-color': colorRef.value })
    }, null, 4),
    _createElementVNode("div", {
      class: "sk-circle8 sk-circle",
      style: _normalizeStyle({ '--spinner-color': colorRef.value })
    }, null, 4),
    _createElementVNode("div", {
      class: "sk-circle9 sk-circle",
      style: _normalizeStyle({ '--spinner-color': colorRef.value })
    }, null, 4),
    _createElementVNode("div", {
      class: "sk-circle10 sk-circle",
      style: _normalizeStyle({ '--spinner-color': colorRef.value })
    }, null, 4),
    _createElementVNode("div", {
      class: "sk-circle11 sk-circle",
      style: _normalizeStyle({ '--spinner-color': colorRef.value })
    }, null, 4),
    _createElementVNode("div", {
      class: "sk-circle12 sk-circle",
      style: _normalizeStyle({ '--spinner-color': colorRef.value })
    }, null, 4)
  ]))
}
}

})